<template>
    <div id="title-settings">
        <div class="form-field">
            <label for="title-input" class="form-label">{{ $t('whatsapp_business_api.headerText') }}</label>
            <input
                type="text"
                id="title-input"
                class="form-input"
                :placeholder="$t('whatsapp_business_api.header')"
                v-model="item.title.titleText"
                @input="updateTitleText(item.title.titleText)"
            >
        </div>
        <div class="form-field">
            <label for="subtitle-input" class="form-label">{{ $t('form.subHeaderText') }}</label>
            <input
                type="text"
                id="subtitle-input"
                class="form-input"
                :placeholder="$t('billing.subHeading')"
                v-model="item.title.subTitle"
                @input="updateSubTitleText(item.title.subTitle)"
            >
            <small class="form-description">{{ $t('form.addSmallTextBelowHeader') }}</small>
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t('form.headerSize') }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: titleSize === 'default' }" @click="updateTitleSize('default')">
                    {{ $t('mail.default') }}
                </button>
                <button class="button" :class="{ active: titleSize === 'wide' }" @click="updateTitleSize('wide')">{{ $t('form.wide') }}
                </button>
                <button class="button" :class="{ active: titleSize === 'small' }" @click="updateTitleSize('small')">
                    {{ $t('form.small') }}
                </button>
            </div>
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t('form.textAlignment') }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: textAlign === 'left' }" @click="updateTextAlign('left')">{{ $t("form.left") }}
                </button>
                <button class="button" :class="{ active: textAlign === 'center' }" @click="updateTextAlign('center')">
                    {{ $t("tables.center") }}
                </button>
                <button class="button" :class="{ active: textAlign === 'right' }" @click="updateTextAlign('right')">{{ $t("form.right") }}
                </button>
            </div>
            <small class="form-description">{{ $t("form.chooseHorizontalAlignment") }}</small>
        </div>
        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="title"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>
        <!--        <div class="option-field">-->
        <!--            <label class="option-label">Alanı gizle</label>-->
        <!--            <div class="toggle">-->
        <!--                <span class="toggle-option" :class="{ active: isHidden }"-->
        <!--                      @click="toggleField">{{ isHidden ? "AÇIK" : "KAPALI" }}</span>-->
        <!--            </div>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "TitleSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            titleText: this.item && this.item.title && this.item.title.titleText ? this.item.title.titleText : "",
            subTitleText: this.item && this.item.title && this.item.title.subTitle ? this.item.title.subTitle : "",
            titleSize: this.item && this.item.title && this.item.title.titleSize ? this.item.title.titleSize : 'default',
            textAlign: this.item && this.item.title && this.item.title.titleAlign ? this.item.title.titleAlign : 'center',
            isHidden: false,
            slug: this.item.slug || '',
            updateTimer: null,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateTitleText(text) {
            this.titleText = text;
            this.$emit("update-title-text", text);
            this.updateField();
        },
        updateSubTitleText(text) {
            this.subTitleText = text;
            this.$emit("update-subtitle-text", text);
            this.updateField();
        },
        updateTitleSize(size) {
            this.titleSize = size;
            this.$emit("update-title-size", size);
            this.updateField();
        },
        updateTextAlign(alignment) {
            this.textAlign = alignment;
            this.$emit("update-text-align", alignment);
            this.updateField();
        },
        toggleField() {
            this.isHidden = !this.isHidden;
            console.log("Field visibility toggled");
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.$emit("update-slug", this.slug);
            this.updateField();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    slug: self.slug,
                    title: {
                        titleText: self.titleText,
                        subTitle: self.subTitleText,
                        titleSize: self.titleSize,
                        titleAlign: self.textAlign,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        }
    },
    watch: {
        'item.title.titleText': function (v) {
            this.titleText = v || '';
        },
        'item.title.subTitle': function (v) {
            this.subTitleText = v || '';
        },
        'item.title.titleSize': function (v) {
            this.titleSize = v || 'default';
        },
        'item.title.titleAlign': function (v) {
            this.textAlign = v || 'center';
        },
        'item.slug': function (v) {
            this.slug = v || '';
        },
        item: {
            deep: true,
            handler: function (val) {
                if (!val || !val.title) return;
                this.titleText = val.title.titleText || '';
                this.subTitleText = val.title.subTitle || '';
                this.titleSize = val.title.titleSize || 'default';
                this.textAlign = val.title.titleAlign || 'center';
                this.slug = val.slug || '';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#title-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }
    }
}
</style>
